<template>
  <organism-self-check-in
    v-model="visitorInfo"
    :display-mode="displayMode"
    :is-valid-x-api-key="isValidXApiKey"
    :is-fetching-site-option="isFetchingSiteOption"
    :redirect-time="redirectTime"
    :site-option="siteOption"
    :available-self-check-in-list="availableSelfCheckInList"
    :check-in-data="checkInData"
    :counter-clear-visitor-info="counterClearVisitorInfo"
    @onFinishReadingVisitorInfo="getVisitorAvailableCheckInList"
    @onSaveXApiKeyToLocalStorage="fetchSiteOptionData"
    @onSaveSelectedSiteIdToLocalStorage="displayMode = 'landing'"
    @onClickRedirectToLandingPage="onClickRedirectToLandingPage"
    @onClearVisitorInfo="setDefaultData"
  ></organism-self-check-in>
  <!-- @onConfirmSelectCheckIn="onConfirmSelectCheckIn" -->
</template>

<script>
import { mapActions } from "vuex"
import {
  getAllSiteList,
  getAvailableCheckInList,
  uploadVisitorImage,
  visitorCheckIn,
} from "@/api/module-1/self-check-in"
import mixins from "@/mixins"
import mixinsDatetime from "@/mixins/mixinsDatetime"
import OrganismSelfCheckIn from "@/components/organisms/selfCheckIn/OrganismSelfCheckIn.vue"
export default {
  name: "SelfCheckIn",
  components: { OrganismSelfCheckIn },
  mixins: [mixins, mixinsDatetime],

  data() {
    return {
      displayMode: "landing",
      redirectInterval: null,
      redirectTime: 0,
      isValidXApiKey: false,
      isFetchingSiteOption: false,
      siteOption: [],
      counterClearVisitorInfo: 0,
      visitorInfo: {
        visitorImage: null,
        visitorImageUrl: "",
        firstname: "",
        lastname: "",
        idType: "",
        idNumber: "",
        expiredDate: "",
        nationality: "",
        address: "",
      },
      availableSelfCheckInList: [
        {
          isSelect: false,
          siteAccessId: "",
          customerName: "",
          requestStartDate: "",
          requestEndDate: "",
          description: "",
        },
      ],
      checkInData: {
        siteId: "",
        selectedSiteAccesses: [
          {
            siteAccessId: "",
            customerName: "",
            requestStartDate: "",
            requestEndDate: "",
          },
        ],
        firstname: "",
        lastname: "",
        idType: "",
        identity: "",
        imageIdentification: "",
        checkInDate: "",
        expiredDate: "",
        nationality: "",
        address: "",
      },
    }
  },

  created() {
    this.setLayoutNavbar(false)
    this.setLayoutSidebar(false)
  },

  mounted() {
    const xApiKey = localStorage.getItem("self-check-in-x-api-key")
    const selectedSiteId = localStorage.getItem(
      "self-check-in-selected-site-id"
    )
    if (!xApiKey || !selectedSiteId) {
      this.displayMode = "setup"
    }
  },

  beforeDestroy() {
    clearInterval(this.redirectInterval)
  },

  methods: {
    ...mapActions("appConfig", ["setLayoutNavbar", "setLayoutSidebar"]),
    async fetchSiteOptionData() {
      this.isFetchingSiteOption = true
      await getAllSiteList()
        .then((response) => {
          if (response) {
            this.isValidXApiKey = true
            this.siteOption = response.data
          }
        })
        .catch((error) => {
          if (error.response?.data?.message === "Unauthorized") {
            this.toastError("Invalid X-API-KEY")
            this.isValidXApiKey = false
            this.displayMode = "setup"
          } else {
            this.toastError("Cannot Connect to Server")
            this.displayMode = "landing"
          }
          this.setDefaultData()
        })
        .finally(() => {
          this.isFetchingSiteOption = false
        })
    },

    async getVisitorAvailableCheckInList() {
      this.displayMode = "processing"
      const idNumber = this.visitorInfo.idNumber
      const selectedSiteId = localStorage.getItem(
        "self-check-in-selected-site-id"
      )
      const visitorIdentityInfo = {
        siteId: selectedSiteId,
        identity: idNumber,
      }
      await getAvailableCheckInList(visitorIdentityInfo)
        .then((response) => {
          if (response) {
            this.availableSelfCheckInList = response.data.map((checkinData) => {
              return {
                ...checkinData,
                isSelect: true,
              }
            })
            if (this.availableSelfCheckInList.length === 0) {
              this.showScreenWithRedirectTimer("not-found", "landing")
            } else if (this.availableSelfCheckInList.length >= 1) {
              this.uploadVisitorImageAndCheckIn()
            }
          }
        })
        .catch((error) => {
          if (error.response?.data?.message === "Unauthorized") {
            this.toastError("Invalid X-API-KEY")
            this.isValidXApiKey = false
            this.displayMode = "setup"
          } else {
            this.toastError("Cannot Connect to Server")
            this.displayMode = "landing"
          }
          this.setDefaultData()
        })
    },

    // onConfirmSelectCheckIn(updatedSelectedCheckIn) {
    //   this.availableSelfCheckInList = updatedSelectedCheckIn
    //   this.uploadVisitorImageAndCheckIn()
    // },

    async uploadVisitorImageAndCheckIn() {
      this.displayMode = "processing"
      const visitorImage = this.visitorInfo.visitorImage

      await uploadVisitorImage(visitorImage)
        .then((response) => {
          if (response) {
            this.visitorInfo.visitorImageUrl = response.data?.image
            this.checkIn()
          }
        })
        .catch((error) => {
          if (error.response?.data?.message === "Unauthorized") {
            this.toastError("Invalid X-API-KEY")
            this.isValidXApiKey = false
            this.displayMode = "setup"
          } else {
            this.toastError("Cannot Connect to Server")
            this.displayMode = "landing"
          }
          this.setDefaultData()
        })
    },

    async checkIn() {
      this.displayMode = "processing"
      const selectedSiteId = localStorage.getItem(
        "self-check-in-selected-site-id"
      )
      const selfCheckInData = {
        siteId: selectedSiteId,
        firstname: this.visitorInfo.firstname,
        lastname: this.visitorInfo.lastname,
        idType: this.visitorInfo.idType,
        identity: this.visitorInfo.idNumber,
        imageIdentification: this.visitorInfo.visitorImageUrl,
        expiredDate: this.formatExpiredDate(
          this.visitorInfo.idType,
          this.visitorInfo.expiredDate
        ),
        nationality: this.visitorInfo.nationality,
        address: this.visitorInfo.address,
        siteAccessIds: this.availableSelfCheckInList
          .filter((checkIn) => checkIn.isSelect)
          .map((checkIn) => checkIn.siteAccessId),
      }
      await visitorCheckIn(selfCheckInData)
        .then((response) => {
          if (response) {
            this.checkInData = response.data
            this.showScreenWithRedirectTimer("check-in-info", "landing")
          }
        })
        .catch((error) => {
          if (error.response?.data?.message === "Unauthorized") {
            this.toastError("Invalid X-API-KEY")
            this.isValidXApiKey = false
            this.displayMode = "setup"
          } else {
            this.toastError("Cannot Connect to Server")
            this.displayMode = "landing"
          }
          this.setDefaultData()
        })
    },

    formatExpiredDate(idType, expiredDate) {
      if (idType.toUpperCase() === "ID_CARD") {
        return this.customFormatDateTime(
          expiredDate,
          "dd/MM/yy",
          "yyyy-MM-dd'T'HH:mm:ss"
        )
      } else {
        return this.customFormatDateTime(
          expiredDate,
          "dd/MM/yyyy",
          "yyyy-MM-dd'T'HH:mm:ss"
        )
      }
    },

    showScreenWithRedirectTimer(beforeTimerMode, afterTimerMode) {
      this.displayMode = beforeTimerMode
      this.redirectTime = 10
      this.redirectInterval = setInterval(() => {
        if (this.redirectTime > 0) {
          this.redirectTime -= 1
        } else {
          this.displayMode = afterTimerMode
          this.setDefaultData()
          clearInterval(this.redirectInterval)
        }
      }, 1000)
    },

    setDefaultData() {
      this.clearVisitorInfo()
      this.clearCheckInData()
      this.clearAvailableCheckInList()
    },

    clearVisitorInfo() {
      this.visitorInfo = {
        visitorImage: null,
        visitorImageUrl: "",
        firstname: "",
        lastname: "",
        idType: "",
        idNumber: "",
        expiredDate: "",
        nationality: "",
        address: "",
      }
      this.counterClearVisitorInfo++
    },

    clearCheckInData() {
      this.checkInData = {
        siteId: "",
        selectedSiteAccesses: [
          {
            siteAccessId: "",
            customerName: "",
            requestStartDate: "",
            requestEndDate: "",
          },
        ],
        firstname: "",
        lastname: "",
        idType: "",
        identity: "",
        imageIdentification: "",
        checkInDate: "",
        expiredDate: "",
        nationality: "",
        address: "",
      }
    },

    clearAvailableCheckInList() {
      this.availableSelfCheckInList = [
        {
          isSelect: false,
          siteAccessId: "",
          customerName: "",
          requestStartDate: "",
          requestEndDate: "",
          description: "",
        },
      ]
    },

    onClickRedirectToLandingPage() {
      this.displayMode = "landing"
      this.clearVisitorInfo()
      clearInterval(this.redirectInterval)
      this.redirectTime = 0
    },
  },
}
</script>

<style lang="scss" scoped></style>
